var scope_0 = require('/var/lib/gitlab-runner/builds/mBENNoof/1/Web/ackee-web-2020/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;export default
        Object.assign({}, scope_0 )
    